import { render, staticRenderFns } from "./EventDialog.vue?vue&type=template&id=26fa74b2&scoped=true"
import script from "./EventDialog.vue?vue&type=script&lang=js"
export * from "./EventDialog.vue?vue&type=script&lang=js"
import style0 from "./EventDialog.vue?vue&type=style&index=0&id=26fa74b2&prod&lang=sass&scoped=true"
import style1 from "./EventDialog.vue?vue&type=style&index=1&id=26fa74b2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fa74b2",
  null
  
)

export default component.exports